import React, { useCallback, useEffect, useState } from 'react';
import { useParams, useNavigate, useOutletContext } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
//api
import { editEditorial, getDetailEditorial, deleteEditorial } from 'api/products';
//components
import Title from 'components/backoffice/texts/title';
import EditorialForm from 'components/backoffice/forms/editorialForm';

const EditorialDetail = () => {
  const { t } = useTranslation(['backoffice']);
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [editorial, setEditorial] = useState({});
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const { setTitle } = useOutletContext()

  const getEditorial = async () => {
    try {
      const { data, status } = await getDetailEditorial(id);
      if (status === 200) {
        setEditorial(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getEditorial();
  }, []);

  useEffect(() => {
    if (editorial) {
      setTitle(t('edit', { title: editorial?.nombre_fiscal }))
    }
    return () => {
      setTitle('');
    };
  }, [editorial, setTitle])

  const onSubmit = useCallback(async (values) => {
    setLoading(true);
    const data = {
      nombre_fiscal: values.nombre_fiscal,
      nombre_comercial: values.nombre_comercial,
      cif: values.cif,
      direccion: values.direccion,
      telefono: values.telefono,
      email: values.email,
      distributor: values.distributor,
      pais: values.pais.id,
      localidad: values.localidad.id,
      url: values.url,
    };

    try {
      const { status } = await editEditorial(id, data);
      if (status === 200) {
        toast.success(t('editadocorrectamente'));
        navigate('/intranet/editorials', { replace: true });
      } else {
        toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  }, []);

  const handleDelete = useCallback(async () => {
    try {
      const { status } = await deleteEditorial(id);
      if (status === 204) {
        toast.success(t('eliminadocorrectamente'));
        navigate('/intranet/editorials', { replace: true });
      } else {
        toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      console.log(error);
    }
  }, [openModalDelete]);

  return (
    <div className="mt-2">
      <Title text={t('editeditorial')} />
      <EditorialForm
        loading={loading}
        isEditing={true}
        onSubmitForm={onSubmit}
        openModalDelete={openModalDelete}
        setOpenModalDelete={setOpenModalDelete}
        defaultValues={editorial}
        onDelete={handleDelete}
        id={id}
      />
    </div>
  );
};

export default EditorialDetail;
